import React from 'react';
import Profilesidebar from '../components/Element/ClientSidebar';
import PlacementAIMS from '../components/Element/PlacementAims/PlacementAIMS';

const Placements = (props) => {
	return (
		<React.Fragment>
			<div className="page-content bg-white">
				<div className="content-block">
					<div className="section-full bg-white browse-job p-t50 p-b20">
						<div className="container">
							<div className="row">
								<Profilesidebar page="placement" />
								<div className="col-xl-9 col-lg-8 m-b30">
									<PlacementAIMS/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}


export default Placements;